import * as React from 'react';
import { SVGProps } from 'react';

const IconMapStrokedSizeM = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21 4.382v12.236l-4.884 2.442-8-2L3 19.618V7.382L7.884 4.94l8 2L21 4.382Zm-6 4.399-6-1.5v7.938l6 1.5V8.781Zm2 7.601 2-1V7.618l-2 1v7.764Zm-10-1V7.618l-2 1v7.764l2-1Z"
    />
  </svg>
);
export default IconMapStrokedSizeM;
